import React, { useState } from 'react';
import { Heart } from 'lucide-react';

const ProductCard7 = ({ product, onClick }) => {
    const [wishlisted, setWishlisted] = useState(false);
    const [hovered, setHovered] = useState(false);

    const handleWishlistToggle = (e) => {
        e.stopPropagation();
        setWishlisted((prev) => !prev);
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&family=Inter:wght@300;400;500&display=swap');
            `}</style>

            <div
                onClick={() => onClick && onClick(product)}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{
                    backgroundColor: '#FFFFFF',
                    border: `1px solid ${hovered ? '#6366F1' : '#E5E7EB'}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    overflow: 'hidden',
                    boxShadow: hovered ? '0 8px 30px rgba(99, 102, 241, 0.12)' : '0 1px 3px rgba(0, 0, 0, 0.06)',
                }}
            >
                {/* Image Container */}
                <div
                    style={{
                        position: 'relative',
                        aspectRatio: '3 / 4',
                        overflow: 'hidden',
                    }}
                >
                    <img
                        src={product.image}
                        alt={product.name}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transform: hovered ? 'scale(1.05)' : 'scale(1)',
                            transition: 'transform 0.5s ease',
                        }}
                    />

                    {/* Badge */}
                    {product.badge && (
                        <span
                            style={{
                                position: 'absolute',
                                top: '12px',
                                left: '12px',
                                backgroundColor: '#6366F1',
                                color: '#FFFFFF',
                                fontFamily: "'Inter', sans-serif",
                                fontSize: '10px',
                                fontWeight: 500,
                                letterSpacing: '1px',
                                textTransform: 'uppercase',
                                padding: '4px 12px',
                                borderRadius: '20px',
                            }}
                        >
                            {product.badge}
                        </span>
                    )}

                    {/* Wishlist Heart */}
                    <button
                        onClick={handleWishlistToggle}
                        style={{
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                            width: '36px',
                            height: '36px',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            border: 'none',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            backdropFilter: 'blur(4px)',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)')}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)')}
                    >
                        <Heart
                            size={18}
                            style={{
                                color: wishlisted ? '#6366F1' : '#9CA3AF',
                                fill: wishlisted ? '#6366F1' : 'none',
                                transition: 'color 0.3s ease, fill 0.3s ease',
                            }}
                        />
                    </button>
                </div>

                {/* Product Info */}
                <div style={{ padding: '16px' }}>
                    <h3
                        style={{
                            fontFamily: "'Inter', sans-serif",
                            fontSize: '14px',
                            fontWeight: 500,
                            color: '#1E1B4B',
                            margin: '0 0 8px 0',
                            lineHeight: 1.4,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {product.name}
                    </h3>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span
                            style={{
                                fontFamily: "'Inter', sans-serif",
                                fontSize: '16px',
                                fontWeight: 500,
                                color: '#9CA3AF',
                            }}
                        >
                            {typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString('en-IN')}` : product.price}
                        </span>
                        {product.originalPrice && (
                            <span
                                style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: '13px',
                                    color: '#D1D5DB',
                                    textDecoration: 'line-through',
                                }}
                            >
                                {typeof product.originalPrice === 'number'
                                    ? `\u20B9${product.originalPrice.toLocaleString('en-IN')}`
                                    : product.originalPrice}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductCard7;
